import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Header.css";

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="header-left">
        <h3 className="header-title">SpotDeal Admin</h3>
      </div>
      <div className="header-right">
        {user && <span className="header-user">{user.name || user.email}</span>}
        <button type="button" className="admin-btn secondary" onClick={handleLogout}>Logout</button>
      </div>
    </header>
  );
};

export default Header;
